// Microphones routinely take up to a second or two to start delivering frames (Bluetooth headsets especially), so a gap that small is normal start-up latency, not lost audio worth interrupting the user over
const MIN_LOST_SECONDS_TO_REPORT = 2;

// MediaRecorder's timeline runs on the wall clock, but a mic that stops delivering frames (Bluetooth profile switch, OS mute, throttled tab) leaves no audio behind for that stretch. The decoded duration is what the user actually got; the difference from the elapsed recording time is how much the mic missed. Returns whole seconds of lost audio, or null when the gap is within normal start-up latency.
export const getLostRecordingSeconds = (
  recordingElapsedS: number,
  decodedDurationS: number
): number | null => {
  const lostSeconds = recordingElapsedS - decodedDurationS;

  // Compared before rounding so a 1.5 s gap, which rounds up to 2, stays below the threshold
  if (lostSeconds < MIN_LOST_SECONDS_TO_REPORT) {
    return null;
  }

  return Math.round(lostSeconds);
};
